(function () {
  const dialog = document.getElementById('nf-add-to-cart-modal');
  if (!dialog) return;

  const productEl = document.getElementById('nf-atc-modal-product');
  const addSources = new Set(['product-form-component', 'volume-pricing', 'b2b-add-to-cart']);
  let openedAt = 0;

  function productName(event) {
    const root = event.target instanceof Element ? event.target : null;
    const card = root?.closest('product-card, .product-card, .nf-list-card');
    const heading =
      card?.querySelector('.product-card__title, .product-title, [data-product-title], h3, h2') ||
      root?.closest('product-form-component')?.closest('.shopify-section')?.querySelector(
        '.product-details h1, .product-information h1, [data-product-title]'
      );
    return heading?.textContent?.replace(/\s+/g, ' ').trim() || '';
  }

  function show(event) {
    const name = productName(event);
    if (productEl) {
      productEl.textContent = name;
      productEl.hidden = name.length === 0;
    }
    if (dialog.open) return;
    try {
      dialog.showModal();
    } catch (error) {
      dialog.setAttribute('open', '');
    }
    openedAt = Date.now();
  }

  function onCart(event) {
    const data = event.detail?.data || {};
    const source = data.source || event.detail?.source;
    if (data.didError) return;
    if (!addSources.has(source)) return;
    show(event);
  }

  document.addEventListener('cart:update', onCart);
  document.addEventListener('cart:add', onCart);

  dialog.addEventListener('click', (event) => {
    const closeButton = event.target instanceof Element && event.target.closest('[data-nf-atc-close]');
    const backdrop = event.target === dialog;
    if (!closeButton && !backdrop) return;
    if (backdrop && Date.now() - openedAt < 400) return;
    if (dialog.open) dialog.close();
  });
})();
